import {
  Breakpoints,
  TextAlignment,
  TextAppearance,
  TextCustomProps,
  TextLineHeight,
  TextSize,
  TextTag,
  TextWeight,
} from '@vw-marketing/us-components';

export const redirectTitleTextStyle: TextCustomProps = {
  appearance: TextAppearance.headline200,
  tag: TextTag.h2,
  style: {
    [Breakpoints.default]: {
      fontSize: TextSize.TextSize32,
      lineHeight: 44,
      fontWeight: TextWeight.bold,
      textAlign: TextAlignment.center,
    },
    [Breakpoints.b560]: {
      fontSize: TextSize.TextSize32,
    },
    [Breakpoints.b1280]: {
      fontSize: 40,
      lineHeight: 44,
    },
  },
};

export const redirectDescriptionTextStyle: TextCustomProps = {
  appearance: TextAppearance.headline200,
  tag: TextTag.p,
  style: {
    [Breakpoints.default]: {
      fontSize: TextSize.TextSize18,
      lineHeight: TextLineHeight.TextLineHeight24,
      fontWeight: TextWeight.light,
      textAlign: TextAlignment.center,
    },
    [Breakpoints.b1280]: {
      fontSize: TextSize.TextSize20,
    },
  },
};

export const redirectCloseTextStyle: TextCustomProps = {
  appearance: TextAppearance.headline200,
  tag: TextTag.span,
  style: {
    fontSize: TextSize.TextSize14,
    lineHeight: TextLineHeight.TextLineHeight16,
    fontWeight: TextWeight.regular,
    textAlign: TextAlignment.center,
  },
};
